import IdentityTile from '@Guidelines/Component/IdentityTile';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const rowStyle = css`
	display: flex;
	align-items: center;
	gap: 0.75rem;
	padding: 0.75rem;
	border-radius: ${theme.radii.large};
	background-color: ${theme.colors.surfaceMuted};
`;

const nameStyle = css`
	flex: 1;
	min-width: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	font-weight: ${theme.fontWeights.medium};
	color: ${theme.colors.ink};
`;

type Props = {
	readonly initials: string;
	readonly seed: number;
	readonly name: React.ReactNode;
	/** The actions on the right of the row. */
	readonly children?: React.ReactNode;
};

/** One person: identity tile, name and, on the right, the actions that apply to them. */
const PersonRow: React.FC<Props> = ({ initials, seed, name, children }) => {
	return (
		<li>
			<div css={rowStyle}>
				<IdentityTile label={initials} seed={seed} />
				<span css={nameStyle}>{name}</span>
				{children}
			</div>
		</li>
	);
};

export default PersonRow;
